import { Accordion, Loader, Text, Image } from '@mantine/core';
import { resolveImagePath } from '@shared/helper';
import { translate } from '@shared/i18n/translate.tsx';
import { useState } from 'react';
import { PhotoView } from 'react-photo-view';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const ImageItem = ({ src }: { src: string }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        minHeight: '190px',
        borderRadius: 20,
        overflow: 'hidden'
      }}
    >
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(255,255,255,0.5)'
          }}
        >
          <Loader />
        </div>
      )}

      <PhotoView src={resolveImagePath(src)}>
        <Image
          h={208}
          src={resolveImagePath(src)}
          style={{ borderRadius: '20px', objectFit: 'cover' }}
          onLoad={() => setIsLoading(false)}
        />
      </PhotoView>
    </div>
  );
};

export const ClubPhotoAccordion = ({ photos }: { photos: string[] }) => (
  <Accordion.Panel>
    {photos?.length ? (
      <Swiper
        navigation
        modules={[Navigation, Pagination]}
        pagination={{ clickable: true }}
        slidesPerView={1}
        spaceBetween={10}
      >
        {photos.map((src, idx) => (
          <SwiperSlide key={idx}>
            <ImageItem src={src} />
          </SwiperSlide>
        ))}
      </Swiper>
    ) : (
      <Text c='dimmed' fz={12}>
        {translate('commons.notFound.generic') ?? 'No photos available'}
      </Text>
    )}
  </Accordion.Panel>
);
